import type { ComponentType } from 'react'

import type { FieldValues } from 'react-hook-form'
import styled from 'styled-components'

import type { FormProps } from '@subaio/components/src/HookForm'
import { Form } from '@subaio/components/src/HookForm'

export const StyledFormPage = styled(Form)`
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	row-gap: 12px;
`

export const FormPage = <T extends FieldValues>(props: FormProps<T>) => (
	<StyledFormPage<ComponentType<FormProps<T>>> as={Form as ComponentType<FormProps<T>>} {...props} />
)
